import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ConnectivityService } from './connectivity.service';

export const connectivityHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);
  const isApi = req.url.startsWith(environment.apiBaseUrl);
  const isHealth = req.url.includes('/health');

  if (!isApi || isHealth) {
    return next(req);
  }

  return next(req).pipe(
    tap((event) => {
      if (event.type !== HttpEventType.Response) return;
      const res = event as HttpResponse<unknown>;
      if (res.status < 500) {
        connectivity.noteApiSuccess();
      } else {
        connectivity.noteApiFailure(new HttpErrorResponse({ status: res.status }));
      }
    }),
    catchError((err: unknown) => {
      connectivity.noteApiFailure(err);
      return throwError(() => err);
    }),
  );
};
